module.exports = __webpack_public_path__ + "static/media/5.30e46659.jpg";